import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "processing-view-backdrop" }
const _hoisted_2 = { class: "processing-view-modal" }
const _hoisted_3 = { class: "processing-header" }
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "processing-content" }
const _hoisted_6 = {
  key: 0,
  class: "polling-indicator"
}

import AIAssistantStartTranscription from "./AIAssistantStartTranscription.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AIAssistantProcessingView',
  props: {
  sessionData: {
    type: Object,
    default: null,
  },
  isPollingActive: {
    type: Boolean,
    default: false,
  },
},
  emits: ["minimize"],
  setup(__props, { emit: __emit }) {

/**
 * AIAssistantProcessingView.vue - Processing State Wrapper
 *
 * Simple centered modal that displays during the processing state.
 * Shows a spinner and "Gerando notas..." message while the transcription
 * is being processed into a summary.
 *
 * This is a thin wrapper that reuses AIAssistantStartTranscription internally.
 */


const emit = __emit;

const onMinimize = () => {
  emit("minimize");
};

return (_ctx: any,_cache: any) => {
  const _component_w_icon = _resolveComponent("w-icon")!
  const _component_w_icon_button = _resolveComponent("w-icon-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_w_icon, {
            name: "smart",
            size: "large"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "processing-title" }, "NOA Notes", -1))
        ]),
        _createVNode(_component_w_icon_button, {
          class: "icon-actions",
          "icon-name": "minus",
          type: "button",
          onClick: onMinimize,
          title: "Minimizar"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(AIAssistantStartTranscription, {
          "summary-status": 'processing',
          "generating-transcription": true,
          "initial-context": __props.sessionData
        }, null, 8, ["initial-context"])
      ]),
      (__props.isPollingActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "status-dot" }, null, -1),
            _createElementVNode("span", { class: "status-text" }, "Processando...", -1)
          ]))]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})